/**
 * Responsible for lazy loading images in the DOM
 * @module lazyLoadImage
 */

import $ from 'jquery';
import throttle from 'lodash/throttle';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import mergeOptions from 'styleguide/lib/merge-options';

export const PLUGIN_NAME = 'lazyLoadImage';
export const LOAD_EVENT = 'load.lazyLoadImage';
export const SCROLL_EVENT = 'scroll.lazyloadimage';
export const DEFAULTS = {};
const $WINDOW = $(window);

/**
 * Handles the scroll event.
 * @param {jQuery} $el - Containing the elements for the lazyLoadImage
 * @param {Object} opts - Options passed along from initialization
 */
function loadImage($el, opts) {
  if($el.attr('data-lazy-triggered-img') === 'false') {
    let imagePosition = $el.offset().top;
    let windowBottomPosition = $WINDOW.scrollTop() + $WINDOW.innerHeight();;
    const imageSrc = $el.attr('data-lazy-img');
    if(windowBottomPosition >= imagePosition) {
      $el.attr('src', imageSrc);
      $el.attr('data-lazy-triggered-img', true);
    }
  }
}

/**
 * Applies any sort of event handlers for lazyLoadImage.
 * @param {jQuery} $el - Containing the elements for the lazyLoadImage
 * @param {Object} options - Options used for wiring up the lazyLoadImage
 * @see DEFAULTS
 */
function applyEventHandlers($el, opts) {
  $WINDOW.on(`${LOAD_EVENT} ${SCROLL_EVENT}`, throttle(function() {
    loadImage($el, opts);
  }, 100));
}

/**
 * Initializes lazyLoadImage based on provided parameters.
 * @param {HTMLElement} el - An element containing the elements for the lazyLoadImage
 * @param {Object} options - Options used for wiring up the lazyLoadImage
 * @see DEFAULTS
 */
 export default function lazyLoadImage(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  $el.attr('data-lazy-triggered-img', false);
  applyEventHandlers($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, lazyLoadImage);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/lazyload-image.js